import { FullStory, init, isInitialized } from "@fullstory/browser";
import React, { useEffect, useContext } from "react";
import { UserContext } from "../UserContext";

const ORG_ID = process.env.REACT_APP_FS_ORG_ID;

export const initFullStory = () => {
  init({ orgId: ORG_ID }); // Replace with your Org ID
};

export const identifyUser = (user) => {
  if (isInitialized()) {
  const isConvertedUser = user.isConvertedUser();
  const isSiaaAgency = user.isSiaaAgency() && !isConvertedUser;

    const tenant = user.getTenant();
    const tenantLevelUserId = user.getTenantLevelUserId();
    const ssoSub = user.getSSOSub();
    let userId = `AgencyIQ-${ssoSub}`;
    
    if (isSiaaAgency && tenant && tenantLevelUserId) {
      userId = `AgencyIQ-${ssoSub}`;
      // userId = `AgencyIQ-${tenant}-${tenantLevelUserId}`;
    } else {
      userId = `DONNA-${tenant}-${tenantLevelUserId}`;
    }
    const userName = `${user.getFirstName()} ${user.getLastName()} (${user.getEmail()})`;
    const sso = user.getSSO();
    const identityProvider = user.getIdentityProvider();
    const ssoCompany = user.getSSOCompany();
    const ssoAgencyId = user.getSSOAgencyId();
    const ssoExternalId = user.getSSOExternalID();
    const ssoEmailID = user.getSSOEmailID();
    const ssoRole = user.getSSORole();
    const isSSO = sso === true || sso === "true" ? true : false;

    FullStory("setIdentity", {
      uid: userId,
      properties: {
        displayName: userName,
        email: user.getEmail(),
        aiq_tenant: user.getTenant(),
        firstName: user.getFirstName(),
        lastName: user.getLastName(),
        aiq_identity_provider: !isSiaaAgency ? "DONNA" : "AgencyIQ",
        ...(isSSO && { aiq_company: ssoCompany }),
        ...(isSSO && { aiq_agency_id: ssoAgencyId }),
        ...(isSSO && { aiq_sub: ssoSub }),
        ...(isSSO && { aiq_external_id: ssoExternalId }),
        ...(isSSO && { aiq_email_id: ssoEmailID }),
        ...(isSSO && { aiq_role: ssoRole }),
      },
    });
  }
};

export function FullStoryProvider(props) {
  const { user } = useContext(UserContext);
  useEffect(async () => {
    initFullStory();
    identifyUser(user);
  }, [user]);

  return <>{props.children}</>;
}
